import { makeStyles } from '@material-ui/core/styles';

export default () => {
    return makeStyles(theme => ({
        titlePopover: {
            fontWeight: "bold"
        }
    }));
};
